import React, { useState, useEffect } from "react";
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Calendar } from "primereact/calendar";
import { addLocale } from "primereact/api";
import { CambiarFormatoFecha } from "../Funciones";
import ConfirmBtn from "./ConfirmBtn";
import Services from "../../service/Services";


const BtnAddService = ({ idContractServiceProp, serviceProp, servicesProp, dateStartServiceProp, dateEndServiceProp, statusProp, serviceCreationDateProp, idProp,
    contractProp, clientProp, createdByProp, creationDateProp, dateEndProp, dateStartProp, dateContractProp, objectContractProp, addServiceContract, setRunRenderProp, 
    runRenderProp, idContractProp, idOtherProp, otherProp }) => {

    const [service, setService] = useState([]);
    const [displayBasic, setDisplayBasic] = useState(false);
    const getService = new Services()

    useEffect(() => {
        if (displayBasic){
        getService.getServices().then(data => setService(data));
        }
    }, [displayBasic])// eslint-disable-line react-hooks/exhaustive-deps

   
    const [setPosition] = useState('center');

    const dialogFuncMap = {
        'displayBasic': setDisplayBasic,
    }

    const onClick = (name, position) => {
        dialogFuncMap[`${name}`](true);
        if (position) {
            setPosition(position);
        }
    }

    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
        resetData()
    }

    const [validateChange, setValidateChange] = useState(false)

    //Obtener datos del select tipo de servicio

    const [selectedService, setSelectedService] = useState({
        name: '',
        id: ''
    })

    const services = service.map(item => {
        const av = { name: item.descripcion, id: parseInt(item.id) }
        return av
    })

    const onServiceChange = (e) => {
        setSelectedService(e.value);
        setValidateChange(true)
    }

    const optionDisabledService = (e) => {
        var disabled = false
        servicesProp.forEach(element => {
            if (element.servicio.id === e.id) {
                disabled = true
            }
        });
        return disabled
    }

    // calendar de fecha  inicio

    const [dateStart, setDateStart] = useState(null);

    const onDateStartChange = (e) => {
        let fecha = e.value
        setDateStart(fecha)
        setValidateChange(true)
    }

    /// calendar de fecha fin

    const [dateEnd, setDateEnd] = useState(null);

    const onDateEndChange = (e) => {
        let fecha = e.value
        setDateEnd(fecha)
        setValidateChange(true)
    }

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    //Validar si hubo algun cambio 

    var changes = false
    if (validateChange === true) {
        changes = true
    }

    //Almacenamos los valores para enviarlos por props

    var idService = selectedService.id

    const resetData = () => {
        setSelectedService({
            id: '',
            name: ''
        })
        setDateStart(null)
        setDateEnd(null)
        setValidateChange(false)
    }

    // Modal para el botón regresar

    const ModalBack = () => {

        const [displayConfirmation, setDisplayConfirmation] = useState(false);
        const [setPosition] = useState('center');

        const dialogFuncMap = {
            'displayConfirmation': setDisplayConfirmation,
        }

        const onClick = (name, position) => {
            dialogFuncMap[`${name}`](true);

            if (position) {
                setPosition(position);
            }
        }

        const onHide = (name) => {
            dialogFuncMap[`${name}`](false);
        }

        const back = (name) => {
            resetData()
            setDisplayBasic(false)
            dialogFuncMap[`${name}`](false);
        }
        const renderFooter = (name) => {
            return (
                <div>
                    <Button label="Cancelar" icon="pi pi-times" onClick={() => onHide(name)} className="p-button-text" />
                    <Button label="Aceptar" icon="pi pi-check" onClick={() => back(name)} autoFocus />
                </div>
            );
        }

        return (
            <>
                <Button label="Regresar" icon="pi pi-times" onClick={() => onClick('displayConfirmation')} className="p-button-text" />

                <Dialog className="dialog-demo" header="Advertencia" visible={displayConfirmation} modal style={{}} footer={renderFooter('displayConfirmation')} onHide={() => onHide('displayConfirmation')}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                        <span style={{ textAlign: 'center' }}>No se ha guardado la información registrada, ¿desea continuar?</span>
                    </div>
                </Dialog>
            </>
        )
    }

    const renderFooter = (name) => {
        return (
            <div>
                {changes ?
                    <ModalBack />
                    :
                    <Button label="Regresar" icon="pi pi-times" onClick={() => onHide(name)} className="p-button-text" />
                }
                {updatePermission ?
                    addServiceContract ?
                        <ConfirmBtn
                            tittle="Confirmar Asignación"
                            menssage="¿Estás seguro de guardar esta información?"
                            action="Update"
                            label="Agregar"
                            icon="pi pi-plus-circle"
                            idClientProp={clientProp.id}
                            contractProp={contractProp}
                            createdByProp={createdByProp}
                            statusProp={statusProp}
                            creationDateProp={creationDateProp}
                            dateStartProp={dateStartProp}
                            dateEndProp={dateEndProp}
                            dateContractProp={dateContractProp}
                            idProp={idProp}
                            objectContractProp={objectContractProp}
                            idContractServiceProp={undefined}
                            statusContractService={1}
                            serviceCreationDateProp={new Date()}
                            dateStartServiceProp={CambiarFormatoFecha(dateStart)}
                            dateEndServiceProp={CambiarFormatoFecha(dateEnd)}
                            idServiceProp={idService}
                            setRunRenderProp={setRunRenderProp}
                            runRenderProp={runRenderProp}
                            setDisplayBasicProp={setDisplayBasic}
                            updateDetailProp={true}
                            deleteDetailProp={false}
                        />
                        :
                        <ConfirmBtn
                            tittle="Confirmar Actualización"
                            menssage="¿Estás seguro de guardar esta información?"
                            action="UpdateOther"
                            label="Actualizar"
                            icon="pi pi-pencil"
                            idOtherProp={idOtherProp}
                            otherProp={otherProp}
                            dateStartProp={dateStartProp}
                            dateEndProp={dateEndProp}
                            idContractProp={idContractProp}
                            statusProp={1}
                            creationDateProp={creationDateProp}
                            createdByProp={createdByProp}
                            OtherServiceStatusProp={1}
                            dateStartServiceProp={CambiarFormatoFecha(dateStart)}
                            dateEndServiceProp={CambiarFormatoFecha(dateEnd)}
                            idOtherServiceProp={undefined}
                            idServiceProp={idService}
                            setRunRenderProp={setRunRenderProp}
                            runRenderProp={runRenderProp}
                            setDisplayBasicProp={setDisplayBasic}
                            updateDetailProp={true}
                            deleteDetailProp={false}
                        />
                    :
                    ""
                }
            </div>
        );
    }
    // validaciones
    // validar fechas dentro del rango del proyecto seleccionado

    var dateStartError = false
    var dateStartMessage = ''

    const validateRangeDate = () => {
        var newDateStart = CambiarFormatoFecha(dateStart)
        var newDateEnd = CambiarFormatoFecha(dateEnd)

        if (newDateStart >= dateStartProp && newDateStart <= dateEndProp &&
            newDateEnd >= dateStartProp && newDateEnd <= dateEndProp) {
            dateStartError = false
            dateStartMessage = ''
        } else {
            dateStartError = true
            dateStartMessage = 'La fecha de inicio y fin están fuera del rango de fechas de vigencia del otro si'
        }
    }

    if (dateStart !== null && dateEnd !== null) {
        if (dateStart > dateEnd) {
            dateStartError = true
            dateStartMessage = 'La fecha inicio vigencia no puede ser mayor a la fecha fin de vigencia'
        } else {
            if (dateStart !== null && dateEnd !== null && dateStartError === false) {
                validateRangeDate()
            }
        }
    }

    var updatePermission = false
    if (dateStart !== null && dateEnd !== null && dateStartError === false && selectedService.id !== '') {
        updatePermission = true
    }

    return (
        <>
            <Button icon="pi pi-plus" label="Agregar servicio" className="btnAdd" onClick={() => {
                onClick('displayBasic')
                resetData()
            }}
                tooltip="Agregar" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
            ></Button>
            <Dialog className="modal" header="Agregar servicio" visible={displayBasic} style={{}} footer={renderFooter('displayBasic')} onHide={() => onHide('displayBasic')}>
                <div className="p-fluid p-formgrid p-grid">
                    <form style={{ display: 'contents' }} >
                        <div className="p-field p-col-12 p-md-12">
                            <label className="labels" >Servicio<span className="require">*</span></label>
                            <Dropdown value={selectedService} options={services} onChange={onServiceChange} placeholder="Seleccione un servicio" filter
                                className="p-column-filter " emptyMessage="No hay resultados" name="service" optionLabel="name" optionDisabled={optionDisabledService}
                            />
                        </div>
                        <div className="p-field p-col-12 p-md-6">
                            <label className="labels" >Fecha Inicio<span className="require">*</span></label>
                            <Calendar placeholder="Seleccione una fecha" value={dateStart} onChange={onDateStartChange} dateFormat="dd-mm-yy" locale="es"
                                className={dateStartError ? "p-invalid" : ""} />
                            <p className="mensajeError">{dateStartError ? dateStartMessage : ""}</p>
                        </div>
                        <div className="p-field p-col-12 p-md-6">
                            <label className="labels" >Fecha Fin<span className="require">*</span></label>
                            <Calendar placeholder="Seleccione una fecha" value={dateEnd} onChange={onDateEndChange} dateFormat="dd-mm-yy" locale="es"
                                className={""}
                            />
                        </div>
                    </form>
                </div>
            </Dialog>
        </>
    )
}

export default BtnAddService